// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_h-0";
export var skeletonCard = "_h-1";